//承运商工作平台模块接口列表

import { base, baseGateway } from "./base"; // 导入接口域名列表
import axios from "@/utils/http"; // 导入http中创建的axios实例

const carrier = {
  // 评价中心
  // 年度评价（上年度）
  postEvaluateLastYear(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/evaluate/selectLastYear`,
      params
    );
  },
  // 年度评价
  postEvaluate(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/evaluate/selectList`,
      params
    );
  },
  // 下拉框
  postDownBox(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/evaluate/selectDropDownBox`,
      params
    );
  },
  // 年度评价详情
  postEvaluateDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/evaluate/select`,
      params
    );
  },
  // 车辆违规记录
  postCar(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/evaluate/car/selectList`,
      params
    );
  },
  // 车辆违规记录-计分客户-下拉框
  postCarCode(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/evaluate/car/selectDropDownBox`,
      params
    );
  },
  // 车辆违规记录-统计
  postCarCount(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/evaluate/car/select`,
      params
    );
  },

  // 我的合同
  postContract(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/contract/selectList`,
      params
    );
  },
  // 我的合同-统计
  postCount(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/contract/selectCount`,
      params
    );
  },

  // 我的合同详情
  postContractDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/contract/select`,
      params
    );
  },
  // 我的合同详情-运单
  postContractTransForm(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/contract/selectTransForm`,
      params
    );
  },

  // 创建提货计划
  postAddPlan(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractPlan/add`,
      params
    );
  },
  // 我的合同 查看下载
  download(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/contract/obtainContractDocuments/${
        params.logisticsContractNum
      }/${params.downloadType}`
    );
  },

  // 运输任务
  // 运输任务-到货管理-到货计划
  postArrivalPlan(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalPlan/selectList`,
      params
    );
  },
  // 运输任务-到货管理-到货计划-下拉框
  postArrivalPlanSelect(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalPlan/selectDropDownBox`,
      params
    );
  },
  // 运输任务-到货管理-到货计划-派车送货(危化)
  postAddDanger(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/sendCar/addDanger`,
      params
    );
  },

  // 创建提单计划
  postTransTaskExtractPlan(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractPlan/add`,
      params
    );
  },

  // 根据合同号 版本号查询物料
  getCustomContractTestSelectByContract(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/customContractTest/selectByContract?contractCode=${
        params.contractCode
      }&revNo=${params.revNo}`
    );
  },

  // 运输任务信息剩余量查询
  postTransTaskSendCarSelect(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/sendCar/select`,
      params
    );
  },

  // 运输任务-到货管理-到货计划-派车送货(普货)--车辆输入建议
  postSelect(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/commonVehicle/page`,
      params
    );
  },
  // postSelect(params) {
  //     return axios.post(`${baseGateway()}/chem-gateway/chem-loms/carrier/car/selectHisList`, params);
  // },
  // 运输任务-到货管理-到货计划-派车送货(普货)
  postAdd(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/sendCar/add`,
      params
    );
  },
  // 运输任务-到货管理-到货单编辑1111
  patchUpdate(params) {
    return axios.patch(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/sendCar/update`,
      params
    );
  },
  // 查询计划剩余计划量
  postLeftCount(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/sendCar/select`,
      params
    );
  },
  // 运输任务-到货管理-到货单管理
  postArrivalFrom(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalFrom/selectList`,
      params
    );
  },
  // 运输任务-到货管理-到货单,提单编辑
  patchArrivalEdit(params) {
    return axios.patch(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalFrom/update`,
      params
    );
  },
  // 运输任务-到货管理-到货单删除
  Fromdelet(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/sendCar/delete?id=${
        params.arrivalFormNum
      }`,
      params
    );
  },
  // 运输任务-到货管理-提单删除
  FromdeletForm(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/sendCar/delete?id=${
        params.billLadingNum
      }`,
      params
    );
  },

  // 运输任务-到货管理-到货单管理-下拉框
  postArrivalFromSelect(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalFrom/selectDropDownBox`,
      params
    );
  },
  // 运输任务-到货管理-到货计划详情
  postArrivalPlanDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalPlan/select`,
      params
    );
  },

  // 运输任务-到货管理-到货单管理详情
  postArrivalFromDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalFrom/select`,
      params
    );
  },

  // 运输任务-提货管理-提货计划
  postExtractPlan(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractPlan/selectList`,
      params
    );
  },
  // 运输任务-提货管理-提货计划-下拉框
  postExtractPlanSelect(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractPlan/selectDropDownBox`,
      params
    );
  },
  // 运输任务-提货管理-提单管理
  postExtractFrom(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractFrom/selectList`,
      params
    );
  },
  // 运输任务-提货管理-提单管理-下拉框
  postExtractFromSelect(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractFrom/selectDropDownBox`,
      params
    );
  },
  // 运输任务-提货管理-提货计划详情
  postExtractPlanDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractPlan/select`,
      params
    );
  },
  // 运输任务-提货管理-提单详情
  postExtractFormDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/extractFrom/select`,
      params
    );
  },
  // 运输任务-常用车辆列表
  postcommonVehicle(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/commonVehicle/page`,
      params
    );
  },
  // 运输任务-我的船舶列表
  postcommonVessel(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/shipInfo/page`,
      params
    );
  },
  // 运输任务-新增常用车辆 承运商
  postAddCommonVehicle(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/commonVehicle/add`,
      params
    );
  },
  // 运输任务-新增常用车辆 除了承运商
  postSaveCommonVehicle(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/commonVehicle/save`,
      params
    );
  },
  // 运输任务-新增我的船舶
  postAddCommonVessel(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/shipInfo/add`,
      params
    );
  },
  // 运输任务-我的船舶详情
  getDetailCommonVessel(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/shipInfo/detail?id=${params}`
    );
  },
  // 运输任务-删除我的船舶
  delCommonVessel(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/shipInfo/del?id=${params}`
    );
  },
  // 运输任务-删除常用车辆
  delCommonVehicle(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/commonVehicle/del`,
      params
    );
  },
  // 运输任务-查询常用车辆环保备案
  // carRecord(params) {
  //     return axios.get(`${baseGateway()}/chem-gateway/chem-loms/commonVehicle/keepOnRecord/${params.licensePlateNum}/${params.taskNum}`);
  // },
  carRecord(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/commonVehicle/keepOnRecordInfo`,
      params
    );
  },
  // 运输任务-编辑，新增常用车辆环保备案
  addCarRecord(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/commonVehicle/keepOnRecord`,
      params
    );
  },
  // 派车数量校验接口
  checkAmount(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/commonVehicle/singleNumValid`,
      params
    );
  },

  // 运输任务-船运管理
  postShip(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/ship/selectList`,
      params
    );
  },
  // 运输任务-船运管理-下拉框
  postShipSelect(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/ship/selectDropDownBox`,
      params
    );
  },
  // 运输任务-船运计划详情
  postShipDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/ship/select`,
      params
    );
  },
  // 运输任务-船运管理-上报商检量
  postShipAddCount(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/ship/add`,
      params
    );
  },
  // 运输任务-船运管理-上报商检报告
  // postShipDetail(params) {
  //     return axios.post(`${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/ship/select`, params);
  // },

  // 查询购销协同类型
  getCustomContractTestGetPscsFlag(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-ctm/customContractTest/getPscsFlag?contractCode=${
        params.contractCode
      }&revNo=${params.revNo}`
    );
  },

  // 车队管理
  // 车队管理-我的车辆列表查询
  postCarSelectList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/selectList`,
      params
    );
  },
  // 车队管理-我的车辆详情
  postCarDeatail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/select`,
      params
    );
  },
  // 车队管理-我的车辆编辑保存
  postCarEdit(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/update`,
      params
    );
  },
  // 车队管理-我的车辆新增-保存
  postCarSave(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/add`,
      params
    );
  },
  // 车队管理-我的车辆-删除
  deleteCar(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/delete`,
      params
    );
  },
  // 车队管理-我的车辆-列表提交
  submitListCar(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/subAudit`,
      params
    );
  },
  // 车队管理-我的车辆-提交审核
  submitCar(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/saveAndAudit`,
      params
    );
  },

  // 车队管理-我的车辆-检查车牌号唯一性
  checkCar(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/checkLicensePlate`,
      params
    );
  },
  // 车队管理-我的车辆-车辆信息上传
  updCarInfo(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/file/upload`,
      params
    );
  },

  // 我的车辆 --删除接口
  delHisCar(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/car/delHisCar`,
      params
    );
  },

  // 车队管理-我的司机列表查询
  driverList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/driver/selectMyList`,
      params
    );
  },
  // 车队管理-我的司机-删除
  driverDel(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/driver/delete`,
      params
    );
  },
  // 车队管理-我的司机-关联司机-添加
  postAddDriver(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/driver/add`,
      params
    );
  },
  // 车队管理-我的司机-关联司机-查询
  postSearchDriver(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/driver/selectOtherList`,
      params
    );
  },

  // 车队管理-我的船舶-查询
  postMyShip(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/ship/selectList`,
      params
    );
  },
  // 车队管理-我的船舶-详情
  postMyShipDetail(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/ship/select`,
      params
    );
  },
  // 车队管理-我的船舶-编辑保存
  patchMyShipEdit(params) {
    return axios.patch(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/ship/update`,
      params
    );
  },
  // 车队管理-我的船舶-新增保存
  patchMyShipSave(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/ship/add`,
      params
    );
  },
  // 车队管理-我的船舶-删除
  deletMyShipDetail(params) {
    return axios.delete(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/ship/delete/${
        params.shipNum
      }`,
      params
    );
  },
  // 结算管理-结算单列表页查询
  settlementList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/page`,
      params
    );
  },
  // 结算管理-结算单详情列表页查询
  settlementDetailList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/info`,
      params
    );
  },
  // 结算管理-导出结算单详情列表页
  exportDetailList(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/exportInfo/${
        params.settlementNum
      }`,
      { responseType: "arraybuffer" }
    );
  },
  // 结算管理-待结算运单列表页查询(我的运单)
  waybillToBeSettledList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/settlementDetailList`,
      params
    );
  },
  // 结算管理- 导出待结算运单列表页(我的运单)
  exportMyWaybill(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/settlementDetailListExport`,
      params,
      { responseType: "arraybuffer" }
    );
  },
  // 结算新接口--------------
  // 待结算运单列表
  waybillToBeSettled(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/settlementDetailList`,
      params
    );
  },
  // 待结算运单列表--物流合同号检索
  logisticsContract(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/logisticsContractNumList?logisticsContractNum=${
        params.logisticsContractNum
      }`
    );
  },
  // 发票列表
  invoiceList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/transInvoiceList`,
      params
    );
  },
  // 发票删除
  invoiceDel(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/deleteInvoice?id=${
        params.id
      }`
    );
  },
  // 发票列表导出
  exportInvoice(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/invoiceListExport`,
      params,
      { responseType: "arraybuffer" }
    );
  },
  // 发票详情
  getInvoiceInfo(params) {
    return axios.get(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/invoiceInfo?id=${
        params.id
      }`
    );
  },
  // 发票保存
  saveInvoice(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/saveInvoice`,
      params
    );
  },
  // 发票提交
  commitInvoice(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrierStatement/commitInvoice`,
      params
    );
  },
  //  发票二维码接口
  invoiceQrcode(params) {
    return axios.post(`${baseGateway()}/chem-gateway/chem-loms/bill`, params);
  },

  // 运输任务-查询磅单号
  selectPoundList(params) {
    return axios.post(
      `${baseGateway()}/chem-gateway/chem-loms/carrier/transTask/arrivalFrom/selectPoundList`,
      params
    );
  },

};
export default carrier;
